import { Action } from '@ngrx/store';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';

export enum OneClickProductsActionTypes {
  LOAD_PRODUCTS = '[One Click] Load products',
  LOAD_PRODUCTS_COMPLETE = '[One Click] Load products completed',
  SELECT_PRODUCT = '[One Click] Select products',
  RESET = '[One Click] products reset',
}

export class OneClickLoadProductsAction implements Action {
  readonly type = OneClickProductsActionTypes.LOAD_PRODUCTS;

  constructor() {}
}

export class OneClickLoadProductsCompleteAction implements Action {
  readonly type = OneClickProductsActionTypes.LOAD_PRODUCTS_COMPLETE;

  constructor(public payload: IProduct[]) {}
}

export class OneClickSelectProductsAction implements Action {
  readonly type = OneClickProductsActionTypes.SELECT_PRODUCT;

  constructor(public payload: IProduct, public index: number) {}
}

export class OneClickResetProductsAction implements Action {
  readonly type = OneClickProductsActionTypes.RESET;

  constructor() {}
}

export type OneClickProductsActions =
  | OneClickLoadProductsAction
  | OneClickLoadProductsCompleteAction
  | OneClickSelectProductsAction
  | OneClickResetProductsAction;
